<template>
  <div>
    <template v-if="sourceName === 'דיסקונט בסיס'">
      <back-navigation-header :on-back="onBack" :disabled="isLoading"/>
      <discount-connection-selection v-if="sourceName === 'דיסקונט בסיס'" :set-source-name="discountConnectionSelected"/>
    </template>
    <credentials-details-with-async-fallback v-else
                                             :source="source"
                                             :handle-back="onBack"
                                             :source-type="source.type"
                                             :loading-start-time="loadingStartTime"
                                             :is-loading="isLoading">
      <template v-slot:credentials>
        <template v-if="sourceName === 'דיסקונט'">
          <credentials-details
                               :invalid-credentials="invalidCredentials"
                               :source="source"
                               :name-already-used-error="nameAlreadyUsedError"
                               :set-name-already-in-use-error="setNameAlreadyInUseError"
                               :save-credentials-error="saveCredentialsError"
                               :on-save="saveCredentials"/>
          <discount-switch-connection :connection-type="sourceName" :switch-connection="switchConnection"/>
        </template>
        <template v-else>
          <discount-credentials-details :name-already-used-error="nameAlreadyUsedError"
                                        :set-name-already-in-use-error="setNameAlreadyInUseError"
                                        :switch-to-regular-discount="switchToRegularDiscount"
                                        :save-pending-credentials="savePendingCredentials"
                                        :validate-name="validateName"
                                        :source="source"/>
          <discount-switch-connection :connection-type="sourceName" :switch-connection="switchConnection"/>
        </template>
      </template>
    </credentials-details-with-async-fallback>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import ShowUnsupportedModalMixin from '../../../unsupported-banks/ShowUnsupportedModalMixin.vue';
import DiscountConnectionSelection from '../../../../../../base-components/onboarding/discount/DiscountConnectionSelection.vue';
import CredentialsDetails from '../../../../../../base-components/onboarding/CredentialsDetails.vue';
import BackNavigationHeader from '../../../../../../base-components/app-header/BackNavigationHeader.vue';
import DiscountCredentialsDetails from '../../../../../../base-components/onboarding/discount/DiscountCredentialsDetails.vue';
import sourcesFields from '../../../../../../constants/sourcesFields';
import CredentialsDetailsWithAsyncFallback
  from '../../../../../../base-components/onboarding/CredentialsDetailsWithAsyncFallback.vue';
import Segment from '../../../../../../Segment';
import DiscountSwitchConnection
  from '../../../../../../base-components/onboarding/discount/DiscountSwitchConnection.vue';

export default {
  name: 'DiscountFlow',
  mixins: [ShowUnsupportedModalMixin],
  components: {
    DiscountSwitchConnection,
    DiscountConnectionSelection,
    BackNavigationHeader,
    DiscountCredentialsDetails,
    CredentialsDetailsWithAsyncFallback,
    CredentialsDetails,
  },
  computed: {
    ...mapState('onboardingState', ['isLoading', 'nameAlreadyUsedError', 'saveCredentialsError', 'loadingStartTime']),
    ...mapGetters('onboardingState', ['invalidCredentials', 'sourceName']),
    source() {
      return _.find(sourcesFields.allSourceFields, { sourceName: this.sourceName });
    },
  },
  methods: {
    ...mapActions('onboardingState', ['deletePageParams', 'saveCredentials', 'savePendingCredentials', 'validateName']),
    ...mapMutations('onboardingState', ['setPageParams', 'setNameAlreadyInUseError']),
    async onBack() {
      if (this.sourceName === 'דיסקונט בסיס') {
        await this.deletePageParams();
      } else {
        await this.deletePageParams({ sourceName: 'דיסקונט בסיס' });
      }
    },
    discountConnectionSelected(connectionType) {
      Segment.trackUserInteraction('DiscountConnectionSelected', { connectionType });
      this.setPageParams({ sourceName: connectionType });
    },
    switchToRegularDiscount() {
      this.discountConnectionSelected('דיסקונט');
    },
    switchConnection() {
      if (this.sourceName === 'דיסקונט') {
        this.discountConnectionSelected('דיסקונט ישיר');
      } else {
        this.discountConnectionSelected('דיסקונט');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/onboard2/steps/bank-selection/DiscountFlow.vue